export default function refreshCsrfForModalLogin() {
    try {
        axios.get('/refresh-csrf')
            .then((response) => {
                let $loginModal = $('#login-modal');
                if(!$loginModal.length) {
                    throw 'Login modal not found';
                }
                let token = $loginModal.find('[name="_token"]')
                if(!token.length) {
                    throw 'Login modal token not found';
                }

                $(token[0]).val(response.data);
                $loginModal.show();
            })
            .catch(error => {
                console.log(error);
                window.location = window.location;
            })
    } catch (error) {
        console.log(error);
        window.location = window.location;
    }
}
